import { createAsyncThunk } from "@reduxjs/toolkit";
import { userId } from "src/helpers/user_id";
import {apiClient} from '../../helpers/api_helper';


export const getFinancing = createAsyncThunk("financing/getFinancing", async () => {
    try {
      const response = await apiClient.get(`/project/provenienciafundo/`);
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const addFinancing = createAsyncThunk("financing/addFinancing", async (financing: any, { dispatch }) => {
    try {
      const response = await apiClient.post(`/project/provenienciafundo/`,{
          nome: financing.name,
          descricao: financing.descricao,
          // valor_previsto: financing.valor_previsto,
          create_user: userId,
          update_user: userId,
        }
      );
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const updateFinancing = createAsyncThunk("financing/updateFinancing", async (financing: any) => {
    try {
      const response = await apiClient.put(`/project/provenienciafundo/${financing.id}/`,{
          nome: financing.name,
          descricao: financing.descricao,
          // valor_previsto: financing.valor_previsto,
          create_user: userId,
          update_user: userId,
        }
      );
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const deleteFinancing = createAsyncThunk("financing/deleteFinancing", async (financingId: any) => {
    try {
      const response = await apiClient.delete(`/project/provenienciafundo/${financingId}/`);
      return response;
    } catch (error) {
      return error;
    }
  }
);


